<template>
    <v-card :loading="loading" :min-height="loading ? 500 : 'auto'">
        <template slot="progress">
            <v-overlay absolute class="d-flex flex-column text-center">
                <div>
                    <v-progress-circular size="250" width="10" color="primary" indeterminate>
                        <span>In curs de incarcare...</span>
                    </v-progress-circular>
                </div>
            </v-overlay>
        </template>
        <v-sheet class="pa-4">
            <v-row>
                <v-col cols="4">
                    <v-autocomplete
                        :items="vehicles"
                        item-value="id"
                        :item-text="(vehicle) => `${vehicle.make.name} ${vehicle.model.name} - ${vehicle.vehicle_plate}`"
                        v-model="form.object_id"
                        v-validate="'required'"
                        :error-messages="errorMessages('object_id')"
                        :class="{ 'error--text': hasErrors('object_id') }"
                        class="primary--text"
                        name="object_id"
                        label="Vehicul"
                        data-vv-as="Vehicul"
                        data-vv-name="object_id"
                    />
                </v-col>
                <v-col cols="4">
                    <v-menu
                        v-model="form.documentDateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="form.document_date"
                                v-validate="'required'"
                                :error-messages="errorMessages('document_date')"
                                :class="{ 'error--text': hasErrors('document_date') }"
                                class="primary--text"
                                name="document_date"
                                label="Data achizitie"
                                data-vv-as="Data achizitie"
                                data-vv-name="document_date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            />
                        </template>
                        <v-date-picker
                            v-model="form.document_date"
                            @input="form.documentDateMenu = false"
                        ></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="4">
                    <v-text-field
                        v-model="form.document_no"
                        v-validate="'required'"
                        :error-messages="errorMessages('document_no')"
                        :class="{ 'error--text': hasErrors('document_no') }"
                        class="primary--text"
                        name="document_no"
                        label="Numar document"
                        data-vv-as="Numar document"
                        data-vv-name="document_no"
                    />
                </v-col>
                <v-col cols="4">
                    <v-autocomplete
                        :items="suppliers"
                        item-value="id"
                        item-text="name"
                        v-model="form.supplier_id"
                        v-validate="'required'"
                        :error-messages="errorMessages('supplier_id')"
                        :class="{ 'error--text': hasErrors('supplier_id') }"
                        class="primary--text"
                        name="supplier_id"
                        label="Furnizor"
                        data-vv-as="Furnizor"
                        data-vv-name="supplier_id"
                    />
                </v-col>

                <v-col cols="8">
                    <v-text-field
                        v-model="form.mileage"
                        v-validate="'required'"
                        :error-messages="errorMessages('mileage')"
                        :class="{ 'error--text': hasErrors('mileage') }"
                        class="primary--text"
                        name="mileage"
                        label="Rulaj actual"
                        data-vv-as="Rulaj actual"
                        data-vv-name="mileage"
                    />
                </v-col>

                <v-col cols="8">
                    <v-textarea
                        v-model="form.remarks"
                        v-validate="''"
                        :error-messages="errorMessages('remarks')"
                        :class="{ 'error--text': hasErrors('remarks') }"
                        class="primary--text"
                        name="remarks"
                        label="Observatii"
                        data-vv-as="Observatii"
                        data-vv-name="remarks"
                    />
                </v-col>
            </v-row>
        </v-sheet>
        <v-divider></v-divider>
        <v-simple-table dense>
            <template v-slot:default>
                <thead>
                <tr>
                    <th class="text-left">
                        Denumire
                    </th>
                    <th class="text-left">
                        U.M
                    </th>
                    <th class="text-right">
                        Cantitate
                    </th>
                    <th class="text-right">
                        Pret Unitar
                    </th>
                    <th class="text-right">
                        Pret Valoare
                    </th>
                    <th class="text-right">
                        Cota TVA
                    </th>
                    <th class="text-right">
                        Valoare TVA
                    </th>
                    <th class="text-right">
                        Total
                    </th>
                    <th class="text-right">
                        Limita timp
                    </th>
                    <th class="text-right">
                        Limita rulaj
                    </th>
                    <th class="text-right">
                        <v-btn color="success" x-small @click="addProduct">Adaugare</v-btn>
                    </th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(item, index) in form.items">
                    <tr :key="`row-${index}`">
                        <td>
                            <v-combobox
                                v-model="item.name"
                                :items="availableItems"
                                v-validate="'required'"
                                :error-messages="errorMessages(`items.${index}.name`)"
                                :class="{ 'error--text': hasErrors(`items.${index}.name`) }"
                                item-text="name"
                                item-value="name"
                                class="primary--text"
                                :name="`items.${index}.name`"
                                label="Denumire produs"
                                data-vv-as="Denumire produs"
                                :data-vv-name="`items.${index}.name`"
                                :return-object="false"
                            ></v-combobox>
                        </td>
                        <td>
                            <v-text-field
                                v-model="item.measurement"
                                v-validate="'required'"
                                :error-messages="errorMessages(`items.${index}.measurement`)"
                                :class="{ 'error--text': hasErrors(`items.${index}.measurement`) }"
                                class="primary--text input-text-right"
                                :name="`items.${index}.measurement`"
                                label="U.M."
                                data-vv-as="U.M."
                                :data-vv-name="`items.${index}.measurement`"
                            />
                        </td>
                        <td>
                            <v-text-field
                                v-model="item.qty"
                                v-validate="'required'"
                                :error-messages="errorMessages(`items.${index}.qty`)"
                                :class="{ 'error--text': hasErrors(`items.${index}.qty`) }"
                                class="primary--text input-text-right"
                                :name="`items.${index}.qty`"
                                label="Cantitate"
                                data-vv-as="Cantitate"
                                :data-vv-name="`items.${index}.qty`"
                                type="number"
                            />
                        </td>
                        <td>
                            <v-text-field
                                :value="(item.amount / item.qty).toFixed(2)"
                                :disabled="true"
                                class="primary--text input-text-right"
                                label="Pret Unitar"
                                data-vv-as="Pret Unitar"
                            />
                        </td>
                        <td>
                            <v-text-field
                                v-model="item.amount"
                                v-validate="'required'"
                                :error-messages="errorMessages(`items.${index}.amount`)"
                                :class="{ 'error--text': hasErrors(`items.${index}.amount`) }"
                                class="primary--text input-text-right"
                                :name="`items.${index}.amount`"
                                label="Valoare"
                                data-vv-as="Valoare"
                                :data-vv-name="`items.${index}.amount`"
                                type="number"
                            />
                        </td>
                        <td>
                            <v-select
                                v-model="item.vat_id"
                                :items="Static.vatRates"
                                item-value="id"
                                item-text="name"
                                v-validate="'required'"
                                :error-messages="errorMessages(`items.${index}.vat_id`)"
                                :class="{ 'error--text': hasErrors(`items.${index}.vat_id`) }"
                                class="primary--text input-text-right"
                                label="Cota TVA"
                                data-vv-as="Cota TVA"
                                :name="`items.${index}.vat_id`"
                                :data-vv-name="`items.${index}.vat_id`"
                            />
                        </td>
                        <td>
                            <v-text-field
                                :value="(item.amount * (1 + parseFloat(_.get(Static.vatRates.find(rate => rate.id === item.vat_id), 'rate', 0)) / 100) - item.amount).toFixed(2)"
                                :disabled="true"
                                class="primary--text input-text-right"
                                label="Valoare TVA"
                                data-vv-as="Valoare TVA"
                            />
                        </td>
                        <td>
                            <v-text-field
                                :value="(item.amount * (1 + parseFloat(_.get(Static.vatRates.find(rate => rate.id === item.vat_id), 'rate', 0)) / 100)).toFixed(2)"
                                :disabled="true"
                                class="primary--text input-text-right"
                                label="Total"
                                data-vv-as="Total"
                            />
                        </td>
                        <td>
                            <v-checkbox v-model="item.hasTimeLimit" @change="(val) => { if(!val) { item.date_expire_start = item.date_expire_end = item.time_expire_notify = undefined; } }"/>
                        </td>
                        <td>
                            <v-checkbox v-model="item.hasMileageLimit" @change="(val) => { if(!val) { item.km_expire = item.km_expire_notify = undefined; } }"/>
                        </td>
                        <td>
                            <v-btn
                                class="ma-2 pull-right"
                                color="error"
                                outlined
                                x-small
                                fab
                                @click="deleteProduct(index)"
                            >
                                <v-icon>mdi-trash-can</v-icon>
                            </v-btn>
                        </td>
                    </tr>
                    <tr v-if="item.hasTimeLimit || item.hasMileageLimit">
                        <td colspan="5" class="pa-3">
                            <v-sheet v-if="item.hasTimeLimit" class="pa-3" elevation="1">
                                <v-row>
                                    <v-col cols="4">
                                        <v-menu
                                            v-model="item.startMenu"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="item.date_expire_start"
                                                    :error-messages="errorMessages(`items.${index}.date_expire_start`)"
                                                    :class="{ 'error--text': hasErrors(`items.${index}.date_expire_start`) }"
                                                    class="primary--text input-text-right"
                                                    :name="`items.${index}.date_expire_start`"
                                                    label="Data inceput"
                                                    data-vv-as="Data inceput"
                                                    :data-vv-name="`items.${index}.date_expire_start`"
                                                    prepend-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                />
                                            </template>
                                            <v-date-picker
                                                v-model="item.date_expire_start"
                                                @input="() => item.startMenu = false"
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-menu
                                            v-model="item.endMenu"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="item.date_expire_end"
                                                    :error-messages="errorMessages(`items.${index}.date_expire_end`)"
                                                    :class="{ 'error--text': hasErrors(`items.${index}.date_expire_end`) }"
                                                    class="primary--text input-text-right"
                                                    :name="`items.${index}.date_expire_end`"
                                                    label="Data sfarsit"
                                                    data-vv-as="Data sfarsit"
                                                    :data-vv-name="`items.${index}.date_expire_end`"
                                                    prepend-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                />
                                            </template>
                                            <v-date-picker
                                                v-model="item.date_expire_end"
                                                @input="item.endMenu = false"
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field
                                            v-model="item.time_expire_notify"
                                            v-validate="''"
                                            :error-messages="errorMessages(`items.${index}.time_expire_notify`)"
                                            :class="{ 'error--text': hasErrors(`items.${index}.time_expire_notify`) }"
                                            class="primary--text input-text-right"
                                            :name="`items.${index}.time_expire_notify`"
                                            label="Notificare (zile)"
                                            data-vv-as="Notificare (zile)"
                                            :data-vv-name="`items.${index}.time_expire_notify`"
                                            type="number"
                                        />
                                    </v-col>
                                </v-row>
                            </v-sheet>
                        </td>
                        <td colspan="6" class="pa-3">
                            <v-sheet v-if="item.hasMileageLimit" class="pa-3" elevation="1">
                                <v-row>
                                    <v-col cols="4">
                                        <v-text-field
                                            v-model="item.km_expire"
                                            v-validate="'required'"
                                            :error-messages="errorMessages(`items.${index}.km_expire`)"
                                            :class="{ 'error--text': hasErrors(`items.${index}.km_expire`) }"
                                            class="primary--text input-text-right"
                                            :name="`items.${index}.km_expire`"
                                            label="Limita KM"
                                            data-vv-as="Limita KM"
                                            :data-vv-name="`items.${index}.km_expire`"
                                            type="number"
                                        />
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field
                                            v-model="item.km_expire_notify"
                                            v-validate="''"
                                            :error-messages="errorMessages(`items.${index}.km_expire_notify`)"
                                            :class="{ 'error--text': hasErrors(`items.${index}.km_expire_notify`) }"
                                            class="primary--text input-text-right"
                                            :name="`items.${index}.km_expire_notify`"
                                            label="Notificare (km)"
                                            data-vv-as="Notificare (km)"
                                            :data-vv-name="`items.${index}.km_expire_notify`"
                                            type="number"
                                        />
                                    </v-col>
                                </v-row>
                            </v-sheet>
                        </td>
                    </tr>
                </template>
                </tbody>
                <tfoot>
                <tr>
                    <td colspan="4">Total</td>
                    <td class="text-right">{{ amountTotal | price }}</td>
                    <td></td>
                    <td class="text-right">{{ vatTotal | price }}</td>
                    <td class="text-right">{{ amountWithVatTotal | price }}</td>
                </tr>
                <tr v-if="hasErrors('items')">
                    <td colspan="11" class="text-center">
                        <v-alert
                            dense
                            type="error"
                        >
                            <template v-for="error in errorMessages('items')">
                                {{ error }}
                            </template>
                        </v-alert>
                    </td>
                </tr>
                </tfoot>
            </template>
        </v-simple-table>


        <v-card-actions v-if="!loading">
            <v-btn
                :loading="form.busy"
                :disabled="errors.any() || form.busy"
                block
                color="success"
                @click="submit()"
            >
                Salveaza
                <v-icon right>
                    save
                </v-icon>
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import validationError from "Mixins/validation-error";
    import {Form} from "vform";

    export default {
        mixins: [validationError],
        props: {
            id: {
                type: [Number, String],
                required: false
            }
        },
        data: () => ({
            tab: 'general',
            loading: true,
            availableItems: [],
            suppliers: [],
            vehicles: [],
            /* Always Declare Your Form Object */
            form: new Form({
                id: null,
                supplier_id: null,
                mileage: null,
                type: 'MAINTENANCE',
                object_type: 'App\\Models\\Vehicles\\Vehicle',
                object_id: null,
                document_date: null,
                document_no: null,
                remarks: null,
                items: [],
                documentDateMenu: false
            })
        }),
        computed: {
            amountTotal() {
                return this.form.items.reduce((total, item) => {
                    return (total + (parseFloat(item.amount)))
                }, 0)
            },
            vatTotal() {
                return this.form.items.reduce((total, item) => {
                    return (total + (item.amount * (1 + parseFloat(this._.get(this.Static.vatRates.find(rate => rate.id === item.vat_id), 'rate', 0)) / 100)) - item.amount)
                }, 0)
            },
            amountWithVatTotal() {
                return this.form.items.reduce((total, item) => {
                    return (total + (item.amount * (1 + parseFloat(this._.get(this.Static.vatRates.find(rate => rate.id === item.vat_id), 'rate', 0)) / 100)))
                }, 0)
            }
        },
        async mounted() {
            await this.loadSuppliers()
            await this.loadVehicles()
            await this.loadAvailableItems()
            if(this.id) {
                await this.loadResource()
            }
            this.loading = false;
        },
        methods: {
            async loadSuppliers() {
                this.suppliers = await this.$db.Supplier
                    .select('id', 'name', 'county_id')
                    .limit(2000)
                    .get()
                    .then(({data}) => data)
            },
            async loadVehicles() {
                this.vehicles = await this.$db.Vehicle
                    .select('id', 'vehicle_plate', 'vehicle_model_id', 'vehicle_brand_id')
                    .include('make', 'model')
                    .limit(2000)
                    .get()
                    .then(({data}) => data)
            },
            async loadAvailableItems() {
                this.availableItems = await this.$db.ExpenseItem
                    .select('id', 'name', 'unit_price')
                    .where('groupByField', 'name')
                    .where('parentType', 'MAINTENANCE')
                    .orderBy('-created_at')
                    .limit(2000)
                    .get()
                    .then(({data}) => data)
            },
            async loadResource() {
                let self = this;
                this.loading = true;

                let data = await this.$db.Expense
                    .include('items')
                    .find(this.id)
                    .then(({data}) => {
                        data.documentDateMenu = false
                        data.items = data.items.map((item) => {
                            return Object.assign({
                                hasTimeLimit: !this._.isNil(item.date_expire_end),
                                hasMileageLimit: !this._.isNil(item.km_expire),
                                startMenu: false,
                                endMenu: false
                            }, item)
                        })
                        return data
                    })
                self.form = new Form(data)
                this.loading = false
            },
            async submit() {
                let self = this;
                this.$validator.validateAll().then(result => {
                    if (result) {
                        // eslint-disable-next-line
                        self.createOrUpdate();
                    } else {
                        this.showError()
                    }
                });
            },
            async createOrUpdate() {
                let self = this;
                self.form.busy = true;

                var model = new this.$db.Expense(self.form);
                if (this.id) {
                    model.id = this.id
                }

                model.save()
                    .then(response => {
                        self.$validator.reset();
                        this.showSuccess();
                        self.$nextTick(() => self.$router.push({name: "vehicle-maintenances-index"}));
                    })
                    .catch(errors => {
                        self.form.errors.set(this.form.extractErrors(errors.response))
                        this.showError()
                    }).finally(() => {
                        self.form.busy = false;
                    });
            },

            addProduct() {
                this.form.items.push({
                    id: undefined,
                    name: undefined,
                    qty: undefined,
                    measurement: undefined,
                    unit_price: undefined,
                    vat_id: undefined,
                    amount: undefined,
                    amount_with_vat: undefined,
                    date_expire_start: undefined,
                    date_expire_end: undefined,
                    time_expire_notify: undefined,
                    km_expire: undefined,
                    km_expire_notify: undefined,
                    hasTimeLimit: false,
                    hasMileageLimit: false,
                    startMenu: false,
                    endMenu: false
                });
            },
            deleteProduct(item) {
                if(this.form.items.length > 1) {
                    this.form.items.splice(item, 1);
                }
            },
        }
    };
</script>
